(() => {
  if (window.__attariyeFuzzySubmitFix) return;
  window.__attariyeFuzzySubmitFix = true;

  const submitSearch = (form, component, input, term) => {
    component.dataset.attariyeFuzzyPass = '1';
    component.activeCorrection = '';
    input.value = term;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      HTMLFormElement.prototype.submit.call(form);
    }
  };

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const component = form.closest('predictive-search');
      if (!component) return;

      if (component.dataset.attariyeFuzzyPass === '1') {
        delete component.dataset.attariyeFuzzyPass;
        return;
      }

      if (component.querySelector('[aria-selected="true"] a')) return;

      const input = form.querySelector('input[type="search"][name="q"]');
      if (!input) return;

      const query = input.value.trim();
      if (!query) return;

      const readyCorrection =
        typeof component.activeCorrection === 'string' ? component.activeCorrection.trim() : '';

      if (readyCorrection && component.searchTerm === query) {
        event.preventDefault();
        submitSearch(form, component, input, readyCorrection);
        return;
      }

      if (
        typeof component.getFuzzyCorrection !== 'function' ||
        typeof component.fetchPredictiveSearch !== 'function'
      ) {
        return;
      }

      const correction = component.getFuzzyCorrection(query);
      if (!correction || correction === query) return;

      event.preventDefault();

      if (component.dataset.attariyeFuzzyChecking === '1') return;
      component.dataset.attariyeFuzzyChecking = '1';

      try {
        const nativeResult = await component.fetchPredictiveSearch(query);
        if (input.value.trim() !== query) return;

        if (nativeResult.productCount > 0) {
          submitSearch(form, component, input, query);
          return;
        }

        const correctedResult = await component.fetchPredictiveSearch(correction);
        if (input.value.trim() !== query) return;

        submitSearch(
          form,
          component,
          input,
          correctedResult.productCount > 0 ? correction : query
        );
      } catch (error) {
        if (input.value.trim() === query) {
          submitSearch(form, component, input, query);
        }
      } finally {
        delete component.dataset.attariyeFuzzyChecking;
      }
    },
    true
  );
})();
